import { useQuery } from '@tanstack/react-query';

import api from '../services/api';

export function usePermission(permission) {
  const isDev = import.meta.env?.DEV;

  const devQuery = useQuery({
    queryKey: ['permission', permission, 'dev'],
    queryFn: async () => true,
    staleTime: 60_000,
    enabled: !!isDev, // Only enable in dev
  });

  const prodQuery = useQuery({
    queryKey: ['permission', permission, 'prod'],
    queryFn: async () => {
      const res = await api.apiClient.get(
        `/check/permission/${encodeURIComponent(permission)}`
      );
      return !!res.data?.has_permission;
    },
    staleTime: 60_000,
    enabled: !isDev, // Only enable in prod
  });

  return isDev ? devQuery : prodQuery;
}
